import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Modal from 'react-modal';
import { getModalStyling } from '../../utils/ModalUtils';
import VerbButton, { VERB_BUTTON_TYPE } from '../VerbButton';
import VerbText from '../VerbText';
import VerbHeading from '../VerbHeading';
import Form from 'react-bootstrap/Form';

const ValidationModal = ({
    messageTextProp,
    cancelButtonProp = {},
    actionButtonProp = {},
    cancelFunc,
    actionFunc,
    isOpen,
    submitError,
    isLoading = false,
    sendEmail=false,
    onToggleSendEmail=()=>{},
}) => {
    if (!messageTextProp) {
        return null;
    }

    const checkBoxWithText = (messageTextProp, isFooter) => {
      const messageId = isFooter ? messageTextProp.footerMessageId : messageTextProp.bodyMessageId;
      const message = isFooter ? messageTextProp.footerMessage : messageTextProp.bodyMessage;
      const marginTop = isFooter ? {marginTop: '16px'} : {marginTop: '0px'};
      return (
      <div className='checkbox-container' style={marginTop}>
        <Form.Check
          className={'confirm-checkbox'}
          type={'checkbox'}
          id={`confirm-checkbox-${messageTextProp.collectionName}`}
          label={''}
          onClick={onToggleSendEmail}
          checked={sendEmail}
      />
        <div className='confirm-text'>
          <VerbText
                messageId={messageId}
                defaultMessage={message}
                valuesToInject={{
                    collectionName: messageTextProp.collectionName,
                }}
          />
        </div>
      </div>)
    };

    const createModalBodyText = (messageTextProp) => {
      const { hasConfirmation, bodyMessageId } = messageTextProp;
 
      if (hasConfirmation && bodyMessageId === 'ASSIGN_COLLECTION') {
        return (checkBoxWithText(messageTextProp, false));
      }
      return (
        <VerbText
        messageId={messageTextProp.bodyMessageId}
        defaultMessage={messageTextProp.bodyMessage}
        valuesToInject={{
            collectionName: messageTextProp.collectionName,
        }}/>);
    };

    const getModalFooterText = (messageTextProp) => {
      const { hasConfirmation, bodyMessageId, footerMessage } = messageTextProp;
      if (footerMessage) {
        if (hasConfirmation && bodyMessageId === 'REPLACE_FEATURED_ASSIGNMENT') {
          return checkBoxWithText(messageTextProp, true);
        }
        return (
          <div className={'row validation-msg-container modal-body'}>
            <VerbText
              messageId={messageTextProp.footerMessageId}
              defaultMessage={messageTextProp.footerMessage}
              valuesToInject={{
                  collectionName: messageTextProp.collectionName,
              }}
            />
          </div>
        );
      }
    };

    return (
        <Modal
          className={cns('verb-modal admin-modal validation-modal')}
          style={getModalStyling({ content: { width: '512px' } })}
          isOpen={isOpen}
          contentLabel={'Modal'}
        >
            <div className={'baseModal main-panel'}>
                <div className={'row validation-msg-container'}>
                    <VerbHeading
                      hNumber={4}
                      messageId={messageTextProp.headerMessageId}
                      defaultMessage={messageTextProp.headerMessage}
                      valuesToInject={{
                          collectionName: messageTextProp.collectionName,
                      }}
                    />
                </div>
                <div className={`row validation-msg-container modal-body ${sendEmail? 'send-email' : ''}`}>
                    { createModalBodyText(messageTextProp) }
                </div>
                    {getModalFooterText(messageTextProp)}
                <div className={'bottom-panel'}>
                    <div className={'row'}>
                        {(cancelButtonProp.textId || cancelButtonProp.defaultMessage) && !isLoading && (
                            <VerbButton
                              className={'col-xs cancel-button'}
                              textId={cancelButtonProp.textId}
                              buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                              defaultMessage={cancelButtonProp.defaultMessage}
                              onClick={cancelFunc}
                            />
                        )}
                        <VerbButton
                          className={`col-xs submit-button validation-button`}
                          type={'submit'}
                          textId={actionButtonProp.textId}
                          defaultMessage={actionButtonProp.defaultMessage}
                          isLoading={isLoading}
                          onClick={actionFunc}
                        />
                    </div>
                </div>
                {submitError ? <div className={'error-msg'}>{submitError}</div> : null}
            </div>
        </Modal>
    );
};

ValidationModal.propTypes = {
    messageTextProp: PropTypes.object,
    cancelButtonProp: PropTypes.object,
    actionButtonProp: PropTypes.object,
    cancelFunc: PropTypes.func,
    actionFunc: PropTypes.func,
    isOpen: PropTypes.bool,
    submitError: PropTypes.string
};

export default ValidationModal;
